import { Divider } from 'antd';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './RightSupplierMenu.scss';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { fetchSuppliers } from '../../../../store/actions/supplier.action';
import { DesignerPageContext } from '../../DesignerPage';
import { capitalize } from 'lodash';
import { openModal } from '../../../../components/common/Modal/openModal';
import ButtonPrimaryLarge from '../../../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonSecondaryLarge from '../../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import {
  checkTextureType,
  getSupplierFromModules,
} from '../../../../utils/modules/ModuleUtils';
import { Trans, useTranslation } from 'react-i18next';
import { setCurrentSupplier } from '../../../../store/reducers/supplier.reducer';
import TabComponent from '../../../../components/common/TabComponent/TabComponent';
import { cn } from '../../../../utils/string/cn.utils';

const RightSupplierMenu = ({
  open,
  onClose,
  // supplierId,
  // setSupplierId,
  otherType,
  type,
  canUseAcrylic,
}) => {
  const { t } = useTranslation();
  const { selectedModels, sceneManager, cabinetType } =
    useContext(DesignerPageContext);

  // const [selectedSupplier, setSelectedSupplier] = useState(null)
  const [textureType, setTextureType] = useState(null);
  const [tab, setTab] = useState(1);

  const dispatch = useDispatch();
  const {
    suppliers,
    currentSupplier: { [type]: supplierId },
    currentSupplier,
  } = useSelector(state => state.supplier);

  useEffect(() => {
    if (
      ['frame', 'louveredWall', 'door', 'bedFlap'].some(item => type === item)
    )
      setTextureType(checkTextureType(selectedModels, canUseAcrylic));
  }, [selectedModels, canUseAcrylic]);

  useEffect(() => {
    if (!canUseAcrylic) {
      setTab(1);
    }
  }, [canUseAcrylic]);

  useEffect(() => {
    if (open) {
      if (textureType && !suppliers.data[textureType]) {
        dispatch(fetchSuppliers({ textureType: textureType }));
      }
      if (otherType && !suppliers.data[otherType]) {
        dispatch(fetchSuppliers({ textureType: otherType }));
      }
    }
  }, [textureType, otherType, open]);

  useEffect(() => {
    if (
      !otherType &&
      textureType &&
      suppliers.data?.[textureType]?.length &&
      !supplierId
    ) {
      // const types = suppliers.data[textureType][0].support_types;

      const currentSupplier = supplierId?.id;
      const supplier = suppliers.data?.[textureType].find(
        item => item.id === currentSupplier
      );
      let material = currentSupplier?.materialType;
      if (supplier) {
        // setSupplierId?.(prev => ({
        //   ...prev,
        //   [textureType]: {
        //     id: supplier.id,
        //     materialType: type,
        //   },
        // }));
        dispatch(
          setCurrentSupplier({
            [type]: {
              ...(supplierId ?? {}),
              ...{ id: supplier.id, material, special: false },
            },
          })
        );
      }
    }
  }, [suppliers.data, textureType, open, otherType]);

  return (
    <RightMenuDesign
      open={open}
      classNames={{ content: 'flex flex-col !p-0 gap-0', root: 'top-84' }}
      header={
        <div className="flex self-stretch items-center justify-start gap-8">
          <ButtonIconGhostMedium
            icon={<Icon.ICArrowBack />}
            onClick={() => onClose()}
          />
          <span className="text-title-large">{t('Supplier')}</span>
        </div>
      }
      content={
        <>
          <div
            className={cn(
              'flex p-[16px] items-start gap-[8px] self-stretch flex-col bg-fills-white',
              !canUseAcrylic && 'hidden'
            )}
          >
            <TabComponent
              items={[
                { key: 1, label: t('Wood') },
                { key: 2, label: t('Acrylic') },
              ]}
              style={{ width: 'fit-content', gap: '0' }}
              activeKey={tab}
              onChange={value => setTab(value)}
            />
          </div>
          <div
            className="right-supplier-menu flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
            style={{ backgroundColor: '#F7F7F7' }}
          >
            <Radio.Group
              value={(() => {
                if (otherType) {
                  return supplierId?.id + '/' + supplierId?.materialType;
                }
                return supplierId?.id + '/' + supplierId?.materialType;
              })()}
              className="flex flex-col gap-8 self-stretch"
              onChange={e => {
                const [id, materialType] = e.target.value?.split('/') ?? [];
                const modules =
                  sceneManager?.cabinetManager?.currentCabinet?.modules;
                const currSuppliers = getSupplierFromModules(modules);
                // 1. Kiểm tra xem supplier của vật liệu đang chọn (supplierId) đã tồn tại trong thiết kế chưa
                const isAlreadyUsed = currSuppliers.some(
                  s => s?.id === id && s?.materialType === materialType
                );
                // 2. Tạo danh sách giả định bao gồm các nhà cung cấp hiện tại + nhà cung cấp mới (nếu chưa có)
                const hypotheticalSuppliers = isAlreadyUsed
                  ? currSuppliers
                  : [...currSuppliers, { id, materialType }];
                // 3. Lọc ra danh sách các nhà cung cấp KHÔNG PHẢI là 'Plastic' và 'Plywood'
                // 'Acrylic' là loại đặc biệt có thể bỏ qua
                // const nonPlasticSuppliers = hypotheticalSuppliers.filter(
                //   s =>
                //     !['Plastic', 'Plywood', 'Acrylic'].some(item =>
                //       s?.materialType?.includes(item)
                //     )
                // );
                const nonAcrylicSuppliers = hypotheticalSuppliers.filter(
                  s =>
                    !['Acrylic'].some(item => s?.materialType?.includes(item))
                );
                const uniqueSuppliers = [
                  ...new Set(nonAcrylicSuppliers.map(s => s?.id)),
                ];

                if (
                  !!otherType &&
                  !['stone', 'glass', 'textile'].some(
                    item => otherType === item
                  )
                  //   ||
                  // (!otherType &&
                  //   ((nonPlasticSuppliers.length > 1 &&
                  //     cabinetType === 'kitchen') ||
                  //     (uniqueSuppliers.length > 1 &&
                  //       cabinetType !== 'kitchen')))
                ) {
                  const result = openModal({
                    title: (
                      <div className="flex justify-between items-center self-stretch">
                        <h4 className="text-title-large">
                          {t('Change supplier')}
                        </h4>
                      </div>
                    ),
                    content: (
                      <span className="text-body-medium">
                        <Trans
                          i18nKey="After clicking the <strong>confirm</strong> button, the old color codes will be deleted."
                          components={{
                            strong: <strong />,
                          }}
                        />
                      </span>
                    ),
                    centered: true,
                    width: 400,
                    classNames: {
                      header: '!p-16 !m-0',
                      body: '!px-16 gap-0',
                      footer: '!p-16 gap-16 items-end flex justify-end',
                    },
                    footer: (
                      <div className="flex justify-end items-center gap-16 self-stretch">
                        <ButtonSecondaryLarge
                          title={t('Cancel')}
                          onClick={() => result.destroy()}
                        />
                        <ButtonPrimaryLarge
                          title={t('Confirm')}
                          onClick={() => {
                            dispatch(
                              setCurrentSupplier({
                                // frame: {
                                //   ...(supplierId ?? {}),
                                //   ...{
                                //     special: false,
                                //   },
                                // },
                                // door: {
                                //   ...(supplierId ?? {}),
                                //   ...{
                                //     special: false,
                                //   },
                                // },
                                // louveredWall: {
                                //   ...(supplierId ?? {}),
                                //   ...{
                                //     special: false,
                                //   },
                                // },
                                [type]: {
                                  id,
                                  materialType,
                                  special: false,
                                },
                              })
                            );
                            if (otherType) {
                            } else {
                              const modules =
                                sceneManager?.cabinetManager?.currentCabinet
                                  ?.modules;
                              const moduleEntries = Array.from(
                                modules.entries()
                              );
                              moduleEntries.forEach(([moduleId, module]) => {
                                sceneManager?.textureController?.clearTexture?.(
                                  module
                                );
                              });
                            }

                            setTimeout(async () => {
                              await sceneManager.calculateTotalCost?.({});
                            }, 100);

                            result.destroy();
                          }}
                        />
                      </div>
                    ),
                  });
                } else {
                  // if (otherType) {
                  //   dispatch(
                  //     setCurrentSupplier({
                  //       [otherType]: {
                  //         id,
                  //         materialType,
                  //       },
                  //     })
                  //   );
                  // } else {
                  dispatch(
                    setCurrentSupplier({
                      [type]: {
                        ...(supplierId ?? {}),
                        ...{
                          id,
                          materialType,
                          special: false,
                        },
                      },
                    })
                  );
                  // }
                }

                onClose();
              }}
            >
              {suppliers.data?.[otherType || textureType]
                ?.filter(
                  item =>
                    (tab == 1 &&
                      !item.support_types?.some(item =>
                        item.includes('Acrylic')
                      )) ||
                    (tab == 2 &&
                      item.support_types?.some(item =>
                        item.includes('Acrylic')
                      ))
                )
                .map((supplier, index) => (
                  <div key={index} className="flex gap-8 self-stretch flex-col">
                    {supplier.support_types?.map(item => {
                      let description = item;
                      if (item === 'L') description = 'Moisture-resistant MDF';
                      else if (item === 'M')
                        description = 'Melamine-coated MDF';
                      console.log(description);
                      return (
                        <>
                          {renderRadio({
                            key: supplier.id + '/' + item,
                            src: supplier.icon_url,
                            value: supplier.id + '/' + item,
                            title: supplier.name,
                            description: t(description),
                          })}
                        </>
                      );
                    })}

                    <Divider
                      type="horizontal"
                      className="m-0 !p-0 bg-outline-default-primary"
                    />
                  </div>
                ))}
            </Radio.Group>
          </div>
        </>
      }
    />
  );
};

export default RightSupplierMenu;

const renderRadio = ({ src, value, title, description, key }) => {
  return (
    <Radio key={key} value={value}>
      <div className="flex items-center justify-start gap-8">
        <div className="flex w-32 h-32 overflow-hidden">
          <img
            className="object-fit-contain w-full self-stretch rounded-[2px]"
            src={src}
            alt=""
          />
        </div>
        <div className="flex flex-col justify-center items-start">
          <span className="text-title-small text-black-high">{title}</span>
          <span className="text-body-small text-black-medium">
            {description}
          </span>
        </div>
      </div>
    </Radio>
  );
};
